/* @flow */

/**
 * AdCOM 1.0 Placement Position Constants
 * Based on AdCOM 1.0 specification - List: Placement Positions
 * These values are used in OpenRTB 2.6 banner.pos field
 *
 * References:
 * - AdCOM 1.0 Specification: https://github.com/InteractiveAdvertisingBureau/AdCOM/blob/main/AdCOM%20v1.0%20FINAL.md#list--placement-positions-
 * - OpenRTB 2.6 Banner Object: https://github.com/InteractiveAdvertisingBureau/openrtb2.x/blob/main/2.6.md#objectbanner
 * - IAB AdCOM Working Group: https://www.iab.com/guidelines/adcom/
 */

const PLACEMENT_POSITIONS = {
  UNKNOWN: 0, // Unknown
  ABOVE_THE_FOLD: 1, // Above the Fold
  LOCKED: 2, // Locked (content that cannot be scrolled away from)
  BELOW_THE_FOLD: 3, // Below the Fold
  HEADER: 4, // Header
  FOOTER: 5, // Footer
  SIDEBAR: 6, // Sidebar
  FULLSCREEN: 7 // Fullscreen
};

/**
 * Get placement position name from code
 * @param {number} code - Placement position code
 * @returns {string} - Human readable name
 */
function getPlacementPositionName(code: number): string {
  const positionNames: { [number]: string } = {
    [PLACEMENT_POSITIONS.UNKNOWN]: 'Unknown',
    [PLACEMENT_POSITIONS.ABOVE_THE_FOLD]: 'Above the Fold',
    [PLACEMENT_POSITIONS.LOCKED]: 'Locked',
    [PLACEMENT_POSITIONS.BELOW_THE_FOLD]: 'Below the Fold',
    [PLACEMENT_POSITIONS.HEADER]: 'Header',
    [PLACEMENT_POSITIONS.FOOTER]: 'Footer',
    [PLACEMENT_POSITIONS.SIDEBAR]: 'Sidebar',
    [PLACEMENT_POSITIONS.FULLSCREEN]: 'Fullscreen'
  };

  return positionNames[code] || 'Unknown';
}

/**
 * Check if placement position code is valid
 * @param {number} code - Placement position code
 * @returns {boolean} - True if valid
 */
function isValidPlacementPosition(code: number): boolean {
  return code >= 0 && code <= 7;
}

export {
  PLACEMENT_POSITIONS,
  getPlacementPositionName,
  isValidPlacementPosition
};
export default PLACEMENT_POSITIONS;
